import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  AemDetail,
  AemRecipeModelData,
  Banner,
  RecipeCategories,
} from "@/utils/types/aem";
import { getAemData } from "./actions";

// Accessing the "banner" object

const DataStructure = {
  isLoading: false,
  isError: false,
  Banner: {} as Banner,
  RecipeCategories: {} as RecipeCategories,
  itemsOrder: [],
  aemFilterData: {},
  sortOptionLabel: "Alphabetical" as string,
};

const GetAemDataSlice = createSlice({
  name: "favourites",
  initialState: DataStructure,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getAemData.pending, (state) => {
      state.isLoading = true;
      state.isError = false;
    });
    builder.addCase(
      getAemData.fulfilled,
      (state, action: PayloadAction<any>) => {
        state.isLoading = false;
        state.isError = false;

        const items =
          action.payload[":items"]?.["root"]?.[":items"]?.["container"]?.[
            ":items"
          ];

        const sortAndFilter =
          items?.["columncontrol"]?.[":items"]?.["column-1"]?.[":items"]?.[
            "sortandfilter"
          ];

        state.aemFilterData = sortAndFilter || null;

        const recipeCategories =
          items?.["columncontrol"]?.[":items"]?.["column-2"]?.[":items"]?.[
            "recipescategories"
          ] || {};

        state.RecipeCategories = {
          recipesCategoriesList: recipeCategories.recipesCategoriesList || [],
          categoriestitle: recipeCategories.categoriestitle || "",
          ":type": recipeCategories[":type"] || "",
        };

        state.itemsOrder =
          action.payload[":items"]?.["root"]?.[":items"]?.["container"]?.[
            ":itemsOrder"
          ] || [];

        state.sortOptionLabel =
          sortAndFilter["sortingOptionsMap"]?.["default"] || "Alphabetical";
      }
    );
    builder.addCase(getAemData.rejected, (state) => {
      state.isLoading = false;
      state.isError = true;
    });
  },
});

const AemModal = createSlice({
  name: "AemData",
  initialState: {
    aemRecipeModelData: {} as AemRecipeModelData,
    aemDetail: {} as AemDetail,
  },
  reducers: {
    setAemData(state: any, action: PayloadAction<AemRecipeModelData>) {
      state.aemRecipeModelData = action.payload;
    },
    setAemDetail(state: any, action: PayloadAction<any>) {
      state.aemDetail = action.payload;
    },
  },
});

export const { setAemData, setAemDetail } = AemModal.actions;

export const AemModalSlice = AemModal.reducer;

export const getAemDataSlice = GetAemDataSlice.reducer;
